module.exports = __webpack_public_path__ + "img/avatar1.000fe655.png";